// websocket client

export enum WebSocketState {
  CONNECTING = 0,
  OPEN,
  CLOSING,
  CLOSED,
  NOT_INIT,
}

interface WebSocketMessageEvent extends Event {
  data?: any;
}
interface WebSocketErrorEvent extends Event {}
export interface WebSocketCloseEvent extends Event {
  code?: number;
  reason?: string;
  message?: string;
}

export class WebScoketClient {
  onOpen: () => void;
  onClose: (event: WebSocketCloseEvent) => void;
  onData: (blob: Uint8Array) => void;
  onError: (e: WebSocketErrorEvent) => void;
  private sock: WebSocket | undefined;

  constructor({ onOpen, onData, onError, onClose }) {
    this.onOpen = onOpen;
    this.onClose = onClose;
    this.onData = onData;
    this.onError = onError;
  }

  connect(url: string) {
    try {
      this.sock?.close();
    } catch (e) {
      // ignore
    }
    this.sock = new WebSocket(url);
    this.sock.binaryType = "arraybuffer";
    this.sock.onopen = this.onOpen;
    this.sock.onclose = this.onClose;
    this.sock.onerror = this.onError;
    this.sock.onmessage = (event: WebSocketMessageEvent) => {
      const blob = new Uint8Array(event.data);
      this.onData(blob);
    };
  }

  send(b: Uint8Array) {
    if (this.ready) {
      return this.sock.send(b);
    }
    console.warn("socket did not initialized");
  }

  close() {
    try {
      this.sock?.close();
    } catch (e) {
      // ignore
    }
  }

  get ready() {
    return this.sock && this.sock.readyState === WebSocketState.OPEN;
  }

  get state() {
    return this.sock ? this.sock.readyState : WebSocketState.NOT_INIT;
  }
}
